import Cookies from 'js-cookie';

export const isFamilyFilterActive = () => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    return ['editor', 'admin'].includes(user.role) && localStorage.getItem('showAllRecipes') !== 'true';
};

export const getEditorIds = async () => {
    const cached = JSON.parse(sessionStorage.getItem('userList'));
    if (cached) return new Set(cached.filter(u => ['editor', 'admin'].includes(u.role)).map(u => u.id));

    try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_ADDRESS}/users`, {
            headers: { 'Authorization': 'Bearer ' + Cookies.get('token') },
        });
        const data = await res.json();
        const users = data.users || [];
        sessionStorage.setItem('userList', JSON.stringify(users));
        return new Set(users.filter(u => ['editor', 'admin'].includes(u.role)).map(u => u.id));
    } catch {
        return new Set();
    }
};

export const filterByFamily = (recipes, editorIds) =>
    recipes.filter(r => editorIds.has(r.created_by));
